import template from './dynamic-filters.view.html';
function DynamicFiltersDirective () {
  return {
    restrict: 'E',
    template
  };
}

DynamicFiltersDirective.$inject = [];

export default DynamicFiltersDirective;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/products-list/dynamic-filters/dynamic-filters.directive.js
 **/